export enum PageViewType {
  EVENT = 'EVENT',
  TICKETS = 'TICKETS',
  EVENT_ATTENDEE_TYPE = 'EVENT_ATTENDEE_TYPE',
}
